import { render, staticRenderFns } from "./AuthInput.vue?vue&type=template&id=3648baf8&scoped=true"
import script from "./AuthInput.vue?vue&type=script&lang=js"
export * from "./AuthInput.vue?vue&type=script&lang=js"
import style0 from "./AuthInput.vue?vue&type=style&index=0&id=3648baf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648baf8",
  null
  
)

export default component.exports